import {Pipe, PipeTransform} from '@angular/core';
import {EventService} from '../services/event.service';

@Pipe({
  name: 'dateFormat',
  standalone: true
})
export class DateFormatPipe implements PipeTransform {

  constructor(private eventService: EventService) {}

  transform(date: any, isFull?: boolean): any {
    if (!date) {
      return '';
    }

    let dateEx = new Date(date);
    let day = dateEx.getDate();
    let monthEx = dateEx.getMonth() + 1;
    let year = dateEx.getFullYear();
    let month = this.eventService.getMonthName(monthEx, true);

    let formattedDate = `${day} ${month} ${year} г.`;

    if (isFull) {
      let hours = dateEx.getHours().toString().padStart(2, '0');
      let minutes = dateEx.getMinutes().toString().padStart(2, '0');
      let seconds = dateEx.getSeconds().toString().padStart(2, '0');

      formattedDate += ` ${hours}:${minutes}:${seconds}`;
    }

    return formattedDate;
  }
}
